import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRateIndexResultsData extends Layout {
    rateIndexMainTable: Table;
    sourceRateIndexResultsData: DataSource;
}
